<template>
  <common-dialog
    v-loading="loadingData"
    ref="dialog"
    title="Edit Goods"
    :inputs-map="goodsInfo"
    :input-value-change="valueChange"
    :save-cb="saveGoodsInfo"
    :reset-inputs="resetGoodsInfo"
  />
</template>
<script>
// others
import get from 'lodash/get'
// models
import { GoodsForm } from '@/core/models/goods'
// mixin
import { dialogMixin } from '@/core/mixin/dialog'
// components
import CommonDialog from '@/components/common/CommonDialog.vue'
import { editGoods, queryGoods } from '@/api/goods'
export default {
  name: 'GoodsEdit',
  mixins: [dialogMixin],
  components: {
    CommonDialog
  },
  data() {
    return {
      idOrData: null,
      goodsInfo: [],
      goodsInfoOriginal: {},
      saveCb: null,
      loadingData: false
    }
  },
  methods: {
    saveGoodsInfo(info, done, error) {
      // // todo 需要检查 输入的东西是否正确
      // const copy = cloneDeep(this.goodsInfoOriginal)
      // info.forEach(one => {
      //   const key = one.key
      //   set(copy, key, one.value)
      // })
      // const copy = GoodsFormWrapUp(this.goodsInfoOriginal)
      if (typeof this.idOrData === 'string') {
        editGoods(this.idOrData, info)
          .then(res => {
            this.$message.success('modify goods successfully!')
            done()
            this.saveCb()
          })
          .catch(err => {
            error(err)
          })
      } else {
        this.saveCb(info, done, error)
      }
    },
    async open(goodsIdOrData, cb) {
      this.idOrData = goodsIdOrData
      this.saveCb = cb
      if (typeof this.idOrData === 'string') {
        // fetch latest data
        this.loadingData = true
        queryGoods({ ids: [this.idOrData] })
          .then(res => {
            // get goods info
            const goods = res?.records?.[0] ?? null
            this.$set(this, 'goodsInfoOriginal', goods)
            this.resetGoodsInfo()
            this.$refs.dialog.open()
          })
          .catch(error => {
            this.$message.error('Failed to get goods data, ' + error)
          })
          .finally(() => {
            this.loadingData = false
          })
      } else {
        // already have data
        this.$set(this, 'goodsInfoOriginal', this.idOrData)
        this.resetGoodsInfo()
        this.$refs.dialog.open()
      }
    },
    valueChange() {},
    resetGoodsInfo() {
      const inputs = Object.keys(GoodsForm).map(key => {
        return {
          ...GoodsForm[key],
          value: get(this.goodsInfoOriginal, key)
        }
      })
      this.$set(this, 'goodsInfo', inputs)
    },
    close() {
      this.idOrData = null
      this.$refs.dialog.close()
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/styles/common.scss';
</style>
